import { Button, Typography } from "@mui/material"
import { postContactSubmitInsurance } from "api"
import { useIsDesktop } from "common/MediaQueries"
import PrivacyPolicyCaption from "common/PrivacyPolicyCaption"
import FormikForm from "common/bit/form/FormikForm"
import { getUtmParamsAsKeyValueList } from "common/bit/utils/utmParams"
import { useState } from "react"
import FormInput from "reusable/formsComp/FormInput"
import FormSuccessState from "reusable/formsComp/FormSuccessState"
import ErrorInFormPopup from "reusable/popups/ErrorInFormPopup"
import styled from "styled-components"
import { TypographyCenter } from "theme/shared"
import schemaInsurance, { initialFormStatesInsurance } from "./SchemaInsurance"

const StyledWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
`
const StyledFormDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 660px;
  }
`
const StyledButton = styled(Button)`
  margin: 20px 0px;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 320px;
  }
`

const StyledRowCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: auto;
  gap: 2px;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    column-gap: 16px;
  }
`
const StyledWrap = styled.div`
  max-width: 100%;
  width: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    max-width: 460px;
    display: flex;
    flex-direction: column;
    align-items: center;
    p {
      width: 400px;
    }
  }
`
const StyledRequiredFields = styled(Typography).attrs({ variant: "body2" })`
  color: ${(p) => p.theme.colors.mazdaRed};
  margin-left: auto;
`

// form status enum
export enum FormStatus {
  Normal = "normal",
  Success = "success",
  Error = "error",
}

const InsuranceForm = () => {
  const [formStatus, setFormStatus] = useState<FormStatus>(FormStatus.Normal)
  const isDesktop = useIsDesktop()

  return (
    <>
      <StyledWrapper>
        {formStatus === FormStatus.Success && <FormSuccessState />}
        {(formStatus === FormStatus.Error ||
          formStatus === FormStatus.Normal) && (
          <>
            <TypographyCenter variant="h2" $mobileRtl $mt="40px">
              לקבלת הצעה משתלמת לביטוח הרכב, {isDesktop && <br />}
              צריך רק להשאיר פרטים ונשמח לחזור בהקדם
            </TypographyCenter>
            <FormikForm
              validationSchema={schemaInsurance}
              initialValues={initialFormStatesInsurance}
              onSubmit={async (values) => {
                const message =
                  values.message?.replaceAll(/https?:\/\/\S+\s*/g, "") || ""
                const utmValues = getUtmParamsAsKeyValueList()
                const formResponse = await postContactSubmitInsurance({
                  subjectId: 0,
                  licensePlate: "",
                  carModelId: 0,
                  showRoomId: 0,
                  firstName: values.firstName,
                  lastName: values.lastName,
                  phone: values.phoneNumber,
                  fax: "",
                  email: values.email,
                  otherPhone: "",
                  description: message,
                  approveMailingList: false,
                  contactSource: isDesktop ? "Pc" : "Mobile",
                  utmValues,
                  sid: window?.__ctm?.config?.sid || "",
                  formName: "Mazda_insurance_form",
                })
                if (formResponse?.data) {
                  setFormStatus(FormStatus.Success)
                } else {
                  setFormStatus(FormStatus.Error)
                }
              }}
              render={(formik) => (
                <StyledFormDiv>
                  <StyledRequiredFields>* שדות חובה</StyledRequiredFields>
                  <StyledRowCol>
                    <FormInput
                      name="firstName"
                      label="שם פרטי"
                      required
                      autoComplete="given-name"
                    />
                    <FormInput
                      name="lastName"
                      label="שם משפחה"
                      required
                      autoComplete="family-name"
                    />
                  </StyledRowCol>
                  <StyledRowCol>
                    <FormInput
                      name="phoneNumber"
                      label="טלפון נייד"
                      autoComplete="tel-national"
                      required
                      type="tel"
                    />
                    <FormInput
                      name="email"
                      label="כתובת מייל"
                      autoComplete="email"
                      required
                      type="email"
                    />
                  </StyledRowCol>
                  <FormInput
                    name="message"
                    label="?איך נוכל לעזור"
                    multiline
                    minRows={4}
                  />
                  <PrivacyPolicyCaption />
                  <StyledWrap>
                    <StyledButton
                      disabled={formik.isSubmitting}
                      fullWidth
                      variant="text"
                      type={"submit"}
                    >
                      שליחה
                    </StyledButton>
                    <TypographyCenter variant="body2" $mobileRtl>
                      הפרטים יועברו לדלק מוטורס ביטוח וישמשו רק כדי ליצור איתך
                      קשר. אל דאגה, לא נשמור אותם ולא נעשה בהם כל שימוש נוסף
                    </TypographyCenter>
                  </StyledWrap>
                </StyledFormDiv>
              )}
            />
          </>
        )}
      </StyledWrapper>
      <ErrorInFormPopup
        open={formStatus === FormStatus.Error}
        onClose={() => setFormStatus(FormStatus.Normal)}
      />
    </>
  );
}

export default InsuranceForm
